import { ImageScaleFactorModel } from './image-scale-factor-model';

export class ImageSizingModel {
  original?: ImageScaleFactorModel = new ImageScaleFactorModel();
  thumbnail: ImageScaleFactorModel = new ImageScaleFactorModel();
  large: ImageScaleFactorModel = new ImageScaleFactorModel();
  gallery?: ImageScaleFactorModel = new ImageScaleFactorModel();

  static defaultImage() {
    return {
      thumbnail: new ImageScaleFactorModel('https://images.ascendtravel.com/NoImage.jpg'),
      large: new ImageScaleFactorModel('https://images.ascendtravel.com/NoImage.jpg')
    };
  }

  static largeSrcSet(image: ImageSizingModel): string {
    return `${image.large['1x']} 1x, ${image.large['2x']} 2x, ${image.large['3x']} 3x`;
  }

  static thumbnailSrcSet(image: ImageSizingModel): string {
    return `${image.thumbnail['1x']} 1x, ${image.thumbnail['2x']} 2x, ${image.thumbnail['3x']} 3x`;
  }
}



// WEBPACK FOOTER //
// ./src/app/model/images/image-sizing-model.ts